import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type CronExpressionBuilder from '../cron-expression-builder.vue'

export const cronExpressionBuilderProps = buildProps({
  value: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideSecond: {
    type: Boolean,
    default: false,
  },
  hideYear: {
    type: Boolean,
    default: false,
  },
  remote: {
    type: Function,
  },
  placeholder: {
    type: String,
    default: 'Cron表达式',
  },
  exeStartTime: {
    type: definePropType([Number, String, Object]),
    default: 0,
  },
  bordered: {
    type: Boolean,
    default: true,
  },
} as const)

export const cronExpressionBuilderEmits = {
  change: (value: string) => !!value,
  'update:value': (value: string) => !!value,
} as const

// props
export type CronExpressionBuilderProps = ExtractPropTypes<
  typeof cronExpressionBuilderProps
>

// emits
export type CronExpressionBuilderEmits = typeof cronExpressionBuilderEmits

// instance
export type CronExpressionBuilderInstance = InstanceType<
  typeof CronExpressionBuilder
>
